import React from 'react';

import Banner from '@atlaskit/banner';
import ErrorIcon from '@atlaskit/icon/glyph/error';

type Props = {
  numberOfIssues: number;
};

export function NoPermissionToViewIssuesBanner({
  numberOfIssues,
}: Props): JSX.Element {
  const issueText = numberOfIssues > 1 ? 'issues' : 'issue';
  return (
    <Banner
      appearance='error'
      icon={<ErrorIcon label='' secondaryColor='inherit' />}
    >
      You don’t have permission to view {numberOfIssues} more {issueText} linked
      here
    </Banner>
  );
}
